function openCloseDynamicAccordionBlade(event) { 

    var elementParent = event.target.parentNode;
    var isOpen = elementParent.classList.contains('accordion__item--open');

    if (isOpen) {
        elementParent.classList.remove('accordion__item--open');
        elementParent.setAttribute('aria-expanded', 'false');
    } else {
        elementParent.classList.add('accordion__item--open');
        elementParent.setAttribute('aria-expanded', 'true');
    }
}

function calculateHeight() {
    document.querySelectorAll('.accordion__item').forEach(function (e) {
        var body = e.querySelector('.accordion__content');
        var height = e.offsetHeight + body.scrollHeight;

        e.style.maxHeight = height + "px";
    });
}

function toggleAccordionItem(event) {
    event.preventDefault();
    var acc_item = event.target.closest('.accordion__item');
    if (!acc_item) return;
    var isOpen = acc_item.classList.contains('accordion__item--open');
    acc_item.classList.toggle('accordion__item--open', !isOpen);
    acc_item.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
}

function applyClicks() {
    document.querySelectorAll('.accordion__title').forEach(function (r) {
        r.addEventListener('click', toggleAccordionItem, false);
    });
}

applyClicks();